<div class="content-heading">
  <div class="header-container">
    <h3>PREINVENTARIO CENTRO DE VENTAS {{currentYear}}</h3>
    <small>Car&aacute;tula de Pre Inventario</small>
  </div>
</div>
<div class="form-container">
  <div class="container-fluid black-text text-font">
    <div class="row d-flex">
        <div class="col-2 red-text center-data">
          <h4 class="center-data">CENTRO DE VENTAS:</h4>
        </div>
        <div class="col-4 ng-autocomplete">
          <ng-autocomplete (selected)='selectEvent($event)' [initialValue]="" [searchKeyword]="keyword" [data]="ceve"
                            [placeholder]="'Escriba un centro de ventas'" [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate">
          </ng-autocomplete>

          <ng-template #itemTemplate let-item>
            <a [innerHTML]="item.CeveName"></a>
          </ng-template>

          <ng-template #notFoundTemplate let-notFound>
            <div [innerHTML]="'No se encontraron coincidencias'"></div>
          </ng-template>

        </div>
        <div class="col-1 red-text center-data">
          <h4>FECHA:</h4>
        </div>
        <div class="col-2 red-text center-data">
          <input title="Fecha" type="date" class="form-control" [(ngModel)]="selectedDate" max="{{ finalDate }}" (ngModelChange)="selectEvent()" [disabled]="!canCreate" />
        </div>
        <div class="col-3 center-data" style="vertical-align: bottom;" hidden>
          <button class="mr-1 btn btn-labeled btn-outline-primary mb-2" (click)="selectEvent()" *ngIf="!disableButton">
            <span class="btn-label">
              <i style="font-size: 1.5em;margin-top:4px;" class="fab fa-codepen" aria-hidden="true"></i>
            </span>
            <span>Calcular Inventario</span>
          </button>
        </div>
    </div>
  </div>
  <br>
  <!-- BEGIN NUEVA DATA -->
  <div id="inventoryCutPage" *ngIf="hasSelected">
    <div *ngIf="status == 'PUBLISHED'" class="row">
      <span>&nbsp;<b>Fecha y hora de posteo: {{modifiedAt}}</b></span>
    </div>
    <div class="data-container black-text" [formGroup]="inventoryForm">
      <table>
        <tr>
          <td>
            <div class="col-3 column_concept_width"><b>
              Estatus: {{
                  status == 'NEW' ? 'NUEVO'
                : status == 'SAVED' ? 'GUARDADO'
                : status == 'CLOSED' ? 'CERRADO'
                : status == 'INCOMPLETESIGNED' ? 'CERRADO'
                : status == 'PUBLISHED' ? 'PUBLICADO'
                : status == 'LAPSED' ? 'CADUCADO'
                : 'OTRO'
              }}
            </b></div>
          </td>
          <td *ngFor="let i of containerData">
            <div class="column_title_width center-data "> <small>{{i.ContainerDescription}}</small></div>
          </td>
        </tr>
        <tr>
          <td>
            <div class="col-3 column_concept_width">
              N&uacute;mero: {{ceveCutId}}
            </div>        
          </td>
          <td *ngFor="let i of containerData">
            <div class="column_title_width center-data">
              <h5>{{i.ContainerName}}</h5>
            </div>
          </td>
        </tr>
      </table>
      <div *ngFor="let row of cutCeveData">
        <table>
          <tr>
            <!--CONCEPT FIELDS-->
            <td *ngIf="row.STYLE == 'line-green'" class="bg-rowtitle full-border bg-green-color"><div class="col-3 column_concept_width">{{row.CONCEPTO}}</div></td>
            <td *ngIf="row.STYLE == 'line-red'" class="bg-rowtitle full-border bg-total-color"><div class="col-3 column_concept_width">{{row.CONCEPTO}}</div></td>
            <td *ngIf="row.STYLE == 'line-blue' && !row.COLLAPSE" class="bg-rowtitle full-border bg-blue-color"><div class="col-3 column_concept_width">{{row.CONCEPTO}}</div></td>
            <td *ngIf="row.STYLE == 'line-gray' && !row.COLLAPSE && !row.CHILD" class="bg-rowtitle full-border" [hidden]="row.HIDE"><div class="col-3 column_concept_width">{{row.CONCEPTO}}</div></td>
            <td *ngIf="row.STYLE == 'line-gray' && row.COLLAPSE" class="bg-rowtitle full-border" [hidden]="row.HIDE">
              <div class="col-3 column_concept_width pointer" (click)="toggleGroupCollapsed(row)" [attr.aria-expanded]="row.GROUPED">
                <div [ngClass]="{'arrow-left': row.GROUPED,'arrow-down': !row.GROUPED }"></div>
                {{row.CONCEPTO}}
              </div>
            </td>
            <td *ngIf="row.STYLE == 'line-blue' && row.COLLAPSE" class="bg-rowtitle full-border bg-blue-color" [hidden]="row.HIDE">
              <div class="col-3 column_concept_width pointer" (click)="toggleGroupCollapsed(row)" [attr.aria-expanded]="row.GROUPED">
                <div [ngClass]="{'arrow-left': row.GROUPED,'arrow-down': !row.GROUPED }"></div>
                {{row.CONCEPTO}}
              </div>
            </td>
            <!--DATA FIELDS-->
            <div *ngIf="row.STYLE == 'line-gray' && !row.CHILD && row.LINE != 10">
              <td class="full-border" *ngFor="let i of containerData">
                  <input *ngIf="row.EDITABLE && (status == 'NEW' || status == 'SAVED')" title="{{row[i.ContainerName]}}" type="number" class="column_width" 
                      value="{{row[i.ContainerName]}}" name="{{row[i.ContainerName]}}" onkeyup="if(this.value<0){this.value= this.value * -1}" 
                      style="text-align:center;" [disabled]="status != 'NEW' && status != 'SAVED'" min="0"
                      (change)="setValue(row,i.ContainerName,$event.target.value)" [hidden]="row.HIDE">
                  <label *ngIf="row.EDITABLE && (status != 'NEW' && status != 'SAVED')" class="column_width" style="text-align:center;" [hidden]="row.HIDE">{{row[i.ContainerName] | number:'1.0':'en'}}</label>
                  <label *ngIf="!row.EDITABLE" class="column_width" style="text-align:center; height: 18px;" [hidden]="row.HIDE">{{row[i.ContainerName] | number:'1.0':'en'}}</label>
              </td>
            </div>
            <div *ngIf="row.STYLE == 'line-gray' && !row.CHILD  && row.LINE == 10"></div>
            <!--COLLAPSE FIELDS-->
            <div *ngIf="row.CHILD" [(collapse)]="row.GROUPED" [isAnimated]="true" [hidden]="row.HIDE">
              <td *ngIf="row.STYLE == 'line-gray' && !row.COLLAPSE && row.CHILD" class="bg-rowtitle full-border">
                <div class="col-3 column_concept_width ">{{row.CONCEPTO}}</div>
              </td>
              <td *ngIf="row.STYLE == 'line-edit' && !row.COLLAPSE && row.CHILD" class="bg-white-color full-border">
                <div class="col-3 column_concept_width ">{{row.CONCEPTO}}</div>
              </td>
              <td class="full-border" *ngFor="let i of containerData">
                  <input *ngIf="row.EDITABLE && (status == 'NEW' || status == 'SAVED')" title="{{row[i.ContainerName]}}" type="number" class="column_width" 
                      value="{{row[i.ContainerName]}}" name="{{row[i.ContainerName]}}" onkeyup="if(this.value<0){this.value= this.value * -1}" 
                      style="text-align:center;" [disabled]="status != 'NEW' && status != 'SAVED'" min="0"
                      (change)="setValue(row,i.ContainerName,$event.target.value)">
                  <label *ngIf="row.EDITABLE && (status != 'NEW' && status != 'SAVED')" class="column_width" style="text-align:center;">{{row[i.ContainerName] | number:'1.0':'en'}}</label>
                  <label *ngIf="!row.EDITABLE" class="column_width" style="text-align:center; height: 18px;">{{row[i.ContainerName] | number:'1.0':'en'}}</label>
              </td>
            </div>
            <!--BLUE AND GREEN FIELDS-->
            <div *ngIf="row.STYLE == 'line-red' && row.LINE == 14">
              <td class="full-border bg-total-color" *ngFor="let i of containerData">
                <label *ngIf="!row.EDITABLE" class="column_width center-data" style="text-align: center; height: 36px;">{{row[i.ContainerName] | number:'1.0':'en'}}</label>
              </td>
            </div>
            <div *ngIf="row.STYLE == 'line-red' && row.LINE != 14">
              <td class="full-border bg-total-color" *ngFor="let i of containerData">
                <label *ngIf="!row.EDITABLE" class="column_width" style="text-align: center; height: 12px;">{{row[i.ContainerName] | number:'1.0':'en'}}</label>
              </td>
            </div>
            <div *ngIf="row.STYLE == 'line-green'">
              <td class="full-border bg-green-color" *ngFor="let i of containerData">
                <label *ngIf="!row.EDITABLE" class="column_width" style="text-align: center; height: 18px;">{{row[i.ContainerName] | number:'1.0':'en'}}</label>
              </td>
            </div>
            <div *ngIf="row.STYLE == 'line-blue'">
              <td class="full-border bg-blue-color" *ngFor="let i of containerData" 
                [ngClass]="{'bg-yellow-color': (row.LINE == 13 && row[i.ContainerName] != teoricoDif[0][i.ContainerName]), 'bg-blue-color':  (1 == 1)}">
                <label *ngIf="!row.EDITABLE" class="column_width" style="text-align: center; height: 18px;">{{row[i.ContainerName] | number:'1.0':'en'}}</label>
              </td>
            </div>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <!--END  NUEVA DATA -->
  <br>

  <div class="row d-flex">
    <div class="col-2" *ngIf="isCeveAdmn && hasSelected && isDateTimeRangeValid && status!='LAPSED'">
      <button class="mr-1 btn btn-labeled btn-outline-primary mb-2" (click)="saveOrEdit(false)" [disabled]="status != 'NEW' && status != 'SAVED'">
        <span class="btn-label">
          <i style="font-size: 1.5em;margin-top:4px;" class="fa fa-save" aria-hidden="true" *ngIf="!isSaving"></i>
          <i style="font-size: 1.5em;margin-top:4px;" class="fa fa-circle-notch fa-spin" *ngIf="isSaving"></i>
        </span>
        <span>Guardar</span>
      </button>
    </div>
  </div>
  <br>
  <!--<p *ngIf="hasSelected && !isDateTimeRangeValid"><b>Nota:</b> Se accedió el día <b>{{actualDateTime.split('T')[0]}}</b> a las <b>{{actualDateTime.split('T')[1]}}</b>. La carátula solo podrá ser capturada entre el día  <b>{{lastEvent.StartAt.toString().split('T')[0]}}</b> a las  <b>{{lastEvent.StartAt.toString().split('T')[1]}}</b> y el día <b>{{lastEvent.EndAt.toString().split('T')[0]}}</b> a las  <b>{{lastEvent.EndAt.toString().split('T')[1]}}</b></p>
  <p *ngIf="hasSelected && isDateTimeRangeValid"><b>Nota:</b> La captura de carátula estará disponible hasta el día <b>{{lastEvent.EndAt.toString().split('T')[0]}}</b> a las <b>{{lastEvent.EndAt.toString().split('T')[1]}}</b></p>-->
  <small *ngIf="hasSelected">Car&aacute;tula de Inventario Versi&oacute;n {{cutVersion}}</small>
  <app-loading *ngIf="isLoading"></app-loading>
</div>